import pako from 'pako'
import { getBlob, getStorage, ref as storageRef, uploadBytes } from 'firebase/storage'

export async function getStorageJson<T = any>(gsPath: string): Promise<T> {
  const storage = getStorage()

  const contentBlob = await getBlob(storageRef(storage, gsPath))

  const text = await contentBlob.text()

  return JSON.parse(text) as T
}

export async function saveStorageJSON(gsPath: string, data: any) {
  const storage = getStorage()

  const contentRef = storageRef(storage, gsPath)

  // gzip and upload content
  const contentBytes = new TextEncoder().encode(JSON.stringify(data))

  const gzippedBytes = pako.gzip(contentBytes)

  return uploadBytes(contentRef, gzippedBytes, {
    contentType: 'application/json',
    contentEncoding: 'gzip',
  })
}
